import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Table,
} from "react-bootstrap";
import _, { toLower } from "lodash";
import InputTextComponent from "../InputTextComponent";
import InputAvatarComponent from "../InputAvatarComponent";
import FileUploadComponent from "../FileUploadComponent";
import Utils from "../../../../utils/index.js";
import config from "../../../../config.js";
import axios from "axios";
import FileList from "../../../FileList/index.js";
import {
  generateAssitantInstanceUUID,
  updateAssistantInstance,
} from "../../../../api/instance_api.js";
import { toast } from "react-toastify";
import { t } from "i18next";
import moment from "moment";
import DropdownComponent from "../DropdownComponent/index.js";
import AddUserContext from "./AddUserContext";

const FormikFormComponent = (props) => {
  const token = Utils.getLocalStorageItem("_t");
  const queryParams = new URLSearchParams(window.location.search);
  const stateValue = queryParams.get("state"); // Gets the 'state' parameter

  const {
    isLoading,
    assistantData,
    inputUi,
    setUserQuestion,
    setUserFormData,
    isFormLoading,
    setIsFormLoading,
    setUserFilelist,
    accessToken,
    fetchFormData,
    setFetchFormData,
    referenceId,
    getAssistantDetails,
    fetchChatToken,
    setAssistantData,
    setInstanceList,
    instanceList,
    currentInstanceId,
    setCurrentInstanceId,
    setContextId,
    instanceName,
    setInstanceName,
    setInitialValues,
    initialValues,
    filelist,
    setFilelist,
    instanceObj,
    setInstanceObj,
    setActiveTab,
    draftFound,
    setDraftFound,
    refresh,
    setRefresh,
    dataurl,
    setDataUrl,
    reset,
    createSseConnection,
    eventSessionRef,
    eventChatCreationRef,
    setInstanceUuId,
    activeTab,
    configk,
    onDataurlUpdate,
    fromWorkflow = false,
    handleFormBlur,
    workflowUuid,
    assistantIndex,
    isEditable = true,
    generateInstanceData,
    uuid,
  } = props;

  const {
    apiGateway: { PLUGIN_BASEURL_API },
  } = config;
  let formikInstance;
  const [uploadProgress, setUploadProgress] = useState(0);
  const [validationSchema, setValidationSchema] = useState(Yup.object());
  const [saveLoading, setSaveLoading] = useState(false);
  const [isProgressVisisble, setProgressVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [fileProcessing, setFileProcessing] = useState(false);
  const [progress, setProgress] = useState(true);
  const formikRef = useRef(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [modalId, setModalId] = useState("");
  const [uploadstatus, setUploadStatus] = useState(false);

  // useEffect(() => {
  //   if(fromWorkflow && Object.keys(instanceObj).length === 0){
  //     generateAssistantInstanceData({assistantUuidreferenceId})
  //   }
  // },[fromWorkflow, instanceObj]);

  useEffect(() => {
    if (draftFound) {
      if (!_.isEmpty(assistantData)) {
        if (!_.isEmpty(assistantData?.instanceData)) {
          _.forEach(assistantData?.instanceData, (instance) => {
            if (instance.status == "draft") {
              handleReuseClick1(instance);
              setTimeout(() => setDraftFound(false), 1000);
            }
          });
        }
      }
    }
  }, [draftFound]);
  useEffect(() => {
    if (fetchFormData) {
      let formData = {};
      let values = formikInstance.values;
      let id = "";
      for (let ui of inputUi) {
        if (ui.type === "file") id = ui._id;
      }
      Object.keys(values).forEach((key) => {
        if (key === "question" || key == id) {
          // setUserQuestion(values[key])
        } else {
          formData[key] = values[key];
        }
      });
      setUserFormData(formData);
    }
  }, [fetchFormData]);

  useEffect(() => {
    if (!_.isEmpty(assistantData) && !fromWorkflow) {
      if (!_.isEmpty(assistantData?.instanceData)) {
        if (instanceList.length == 0) {
          _.forEach(assistantData?.instanceData, (instance) => {
            if (instance.status == "draft") {
              // setActiveTab('context')
              handleReuseClick1(instance);
            }
          });
        }
        setInstanceList(
          _.filter(
            assistantData?.instanceData,
            (instance) => fromWorkflow || !instance?.isWorkflow
          ).map((instance) => {
            return {
              name: instance.instanceName ? instance.instanceName : "",
              status: instance.status == "draft" ? "Draft" : "Saved",
              createdAt: moment(instance.createdAt).format(
                "Do MMMM, YYYY HH:mm a"
              ),
              action: renderReUseActionBtn(instance),
              instanceUuid: instance?.instanceUuid,
            };
          })
        );
      } else {
        generateAssistantInstanceData({
          assistantUuid: assistantData.uuid,
        });
      }
    }
  }, [assistantData]);
  useEffect(() => {
    if (!_.isEmpty(assistantData)) {
      const instanceArr = _.sortBy(
        assistantData?.instanceData,
        "createdAt"
      ).reverse();
      let instance =
        assistantData?.instanceData[assistantData?.instanceData.length - 1];
      setCurrentInstanceId(instance ? instance.instanceUuid : "");
      // setContextId(instance ? instance._id : "");
      setContextId(instanceArr[0]?.instanceUuid);
      setInstanceObj(instanceArr[0]);
    }
  }, [assistantData?.instanceData.length]);
  const statusUpdate = async () => {
    setUploadStatus(true);
    const isFetchCompleted = await fetchFiles();

    if (isFetchCompleted) {
      setTimeout(() => {
        setUploadStatus(false);
      }, 3000);
    } else {
      setUploadStatus(false);
    }
  };
  useEffect(() => {
    if (
      !_.isEmpty(instanceObj) &&
      instanceObj?.instanceFormData &&
      (fromWorkflow || !instanceObj.isWorkflow)
    ) {
      setInstanceName(
        instanceObj?.instanceName ? instanceObj?.instanceName : ""
      );
      const initVal = _.cloneDeep(initialValues);
      for (let data of instanceObj?.instanceFormData) {
        // Object.keys(initVal).forEach((val) => {
        // if (data.id == val) {
        initVal[data?.id] = data.value;
        // initVal[data?.uuid] = data.value;
        // }
        // });
      }
      setInitialValues(initVal);
      fetchFiles(instanceObj?.instanceUuid);
    }
  }, [instanceObj]);
  function createDynamicSchema(fields, data) {
    let schema = Yup.object();

    fields.forEach((field) => {
      if (field.type !== "file") {
        let fieldValidation;

        if (field.type === "avatar") {
          fieldValidation = Yup.mixed();
        } else {
          fieldValidation = Yup.string().trim();
        }

        if (field.required === true) {
          if (field.type === "urllink") {
            fieldValidation = fieldValidation.when([], {
              is: () => _.isEmpty(data),
              then: (schema) => schema.required("This field is required"),
              otherwise: (schema) => schema.notRequired(),
            });
          } else if (field.type === "avatar") {
            fieldValidation = fieldValidation.test(
              "required-avatar",
              "This field is required",
              (value) => !!(value && _.keys(value).length > 0)
            );
          } else {
            fieldValidation = fieldValidation.required(
              "This field is required"
            );
          }
        }
        if (field.type === "avatar") {
          fieldValidation = fieldValidation.test(
            "avatar-shape",
            "Invalid avatar selection",
            (value) =>
              !value || typeof value === "object" || typeof value === "string"
          );
        }
        if (field.type === "urllink") {
          fieldValidation = fieldValidation
            .matches(
              /^(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/i,
              "Enter a correct URL!"
            )
            .test("unique-url", "This URL already exists!", (value) => {
              if (!value) return true;
              return !data.some(
                (item) => item.url.toLowerCase() === value.toLowerCase()
              );
            });
        }
        schema = schema.shape({
          [field._id]: fieldValidation,
        });
      }
    });

    return schema;
  }

  useEffect(() => {
    if (_.isArray(inputUi) && !_.isEmpty(inputUi)) {
      setValidationSchema(createDynamicSchema(inputUi, dataurl));
      if (!refresh) {
        // let initialV = _.cloneDeep(initialValues);
        // for (let ui of inputUi) {
        //   initialV[`${ui._id}`] = "";
        // }
        // setInitialValues(initialV);
        // fetchFiles(
        //   assistantData?.instanceData?.filter((instance)=>instance.instanceName==instanceName)
        //     ?.instanceUuid
        // );
      } else {
        setRefresh(false);
      }
    }
  }, [inputUi, dataurl]);
  // useEffect(() => {
  //   if (assistantData) {
  //     fetchFiles(
  //       assistantData?.instanceData[assistantData.instanceData.length - 1]
  //         ?.instanceUuid
  //     );
  //   }
  // }, [assistantData]);

  useEffect(() => {
    if (isFormLoading) {
      formikInstance.setFieldValue("question", "");
    }
  }, [isFormLoading]);

  const fetchFiles = async (instanceId = instanceObj?.instanceUuid) => {
    if (accessToken) {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}filehandler/files`,
        {
          referenceId: referenceId,
          referenceType: "Instance",
          instanceId: instanceId,
        },
        {
          headers: { "x-access-token": token },
        }
      );
      if (response?.data?.data) {
        setFilelist(
          response?.data?.data?.map((item) => {
            let step = 0;
            let message = item.message || "";

            if (item.status === "Y" || item.status === "E") {
              step = 4;
              message = "";
              item.isProcessed = true;
            } else if (item.status === "I") {
              if (item.proccessedChunks === 0) {
                step = 2;
                message = "Processing started. Preparing data for analysis...";
              } else if (item.proccessedChunks > 0) {
                step = 3;
                message = `Processing in progress: ${item.proccessedChunks} out of ${item.totalChunks} chunks completed.`;
              }
            } else if (item.status === "N") {
              step = 1;
              message = "File sent for vector processing. Please wait...";
            }

            return {
              ...item,
              step,
              message,
            };
          })
        );
      }
      if (response?.data?.url) {
        setDataUrl(response?.data?.url);
      } else {
        setDataUrl([]);
      }
    } else {
      setTimeout(() => onFileUpload(), 5000);
    }
  };
  // da020ca0-c135-46fc-8506-56f11061f6b4
  useEffect(() => {
    fetchFiles();
  }, [instanceObj?.instanceUuid]);

  const onFileUpload = async () => {
    if (accessToken) {
      const response = await axios.get(`${PLUGIN_BASEURL_API}`, {
        headers: { "x-access-token": accessToken },
      });
      setFilelist([...response.data]);
      if (response.data.length != 0) {
        setUserFilelist(response.data[0]);
      }
    } else {
      setTimeout(() => onFileUpload(), 5000);
    }
  };

  const renderInputUI = (key, data, formik) => {
    const componentsMap = {
      txt: (
        <InputTextComponent
          key={key}
          id={data._id}
          label={data.label}
          title={data.title}
          description={data.description}
          formik={formik}
          required={data.required}
          fromWorkflow={fromWorkflow}
          handleFormBlur={handleFormBlur}
          isEditable={isEditable}
          defaultValue={data?.defaultValue}
          hidden={data?.hidden}
        />
      ),
      avatar: (
        <InputAvatarComponent
          key={key}
          id={data._id}
          title={data.title}
          description={data.description}
          formik={formik}
          required={data.required}
          fromWorkflow={fromWorkflow}
          handleFormBlur={handleFormBlur}
          isEditable={isEditable}
          options={data?.options}
          defaultValue={data?.defaultValue}
          hidden={data?.hidden}
        />
      ),
      file: (
        <>
          <FileUploadComponent
            uuid={uuid}
            key={key}
            id={data._id}
            label={data.label}
            title={data.title}
            description={data.description}
            allowedFileTypes={data.selectedFileTypes}
            formik={formik}
            onFileUpload={onFileUpload}
            accessToken={accessToken}
            setUploadProgress={setUploadProgress}
            setFilelist={setFilelist}
            BASEURL={PLUGIN_BASEURL_API}
            multipleFiles={filelist}
            setProgressVisible={setProgressVisible}
            isProgressVisisble={isProgressVisisble}
            referenceId={referenceId}
            fetchFiles={fetchFiles}
            instanceId={instanceObj?.instanceUuid}
            fileProcessing={fileProcessing}
            progress={progress}
            setProgress={setProgress}
            fromWorkflow={fromWorkflow}
            handleFormBlur={handleFormBlur}
            assistantData={assistantData}
            workflowUuid={workflowUuid}
            isEditable={isEditable}
            generateInstanceData={generateInstanceData}
            uploadstatus={uploadstatus}
            setUploadStatus={setUploadStatus}
            defaultValue={data?.defaultValue}
            hidden={data?.hidden}
          />
          <FileList
            docList={filelist}
            fetchFiles={fetchFiles}
            uploadProgress={uploadProgress}
            filesEndRef={null}
            setProgressVisible={setProgressVisible}
            isProgressVisisble={isProgressVisisble}
            progress={progress}
            isEditable={isEditable}
            uploadstatus={uploadstatus}
            statusUpdate={statusUpdate}
          />
        </>
      ),
      dropDown: (
        <DropdownComponent
          key={key}
          id={data._id}
          title={data?.title}
          description={data?.description}
          formik={formik}
          required={data?.required}
          options={
            Array.isArray(data?.options)
              ? data?.options.map((option) =>
                  typeof option === "string"
                    ? { label: option, value: option }
                    : option
                )
              : []
          }
          fromWorkflow={fromWorkflow}
          handleFormBlur={handleFormBlur}
          isEditable={isEditable}
          defaultValue={data?.defaultValue}
          hidden={data?.hidden}
        />
      ),
      urllink: (
        <InputTextComponent
          key={key}
          id={data._id}
          label={data.label}
          title={data.title}
          description={data.description}
          formik={formik}
          referenceId={referenceId}
          dataurl={dataurl}
          fetchdata={fetchFiles}
          type={data.type}
          instanceUuid={instanceObj?.instanceUuid}
          required={data.required}
          setFilelist={setFilelist}
          activeTab={activeTab}
          eventSessionRef={eventSessionRef}
          eventChatCreationRef={eventChatCreationRef}
          onDataurlUpdate={onDataurlUpdate}
          fromWorkflow={fromWorkflow}
          handleFormBlur={handleFormBlur}
          assistantIndex={assistantIndex}
          isEditable={isEditable}
          defaultValue={data?.defaultValue}
          hidden={data?.hidden}
        />
      ),
      longtxt: (
        <InputTextComponent
          key={key}
          id={data._id}
          label={data.label}
          title={data.title}
          description={data.description}
          formik={formik}
          type={data.type}
          required={data.required}
          fromWorkflow={fromWorkflow}
          handleFormBlur={handleFormBlur}
          isEditable={isEditable}
          defaultValue={data?.defaultValue}
          hidden={data?.hidden}
        />
      ),
    };

    return componentsMap[data.type] || null;
  };

  const handleReuseClick1 = async (instance) => {
    reset();
    const newValues = {};
    instance.instanceFormData.forEach((item) => {
      if (item.title !== "Upload File") newValues[item?._id] = item.value;
    });
    if (formikRef.current) {
      formikRef.current.setValues(newValues);
    }
    const response = await fetchChatToken(
      assistantData?.pluginId,
      assistantData?.uuid
    );
    if (!_.isEmpty(response)) {
      const respData = response.data;
      if (!_.isEmpty(respData.data)) {
        const accessToken = respData.data?.accessToken;
        const assistantInfo = _.clone(assistantData);
        assistantInfo.accessToken = accessToken;
        setAssistantData(assistantInfo);
      }
    }
    setInitialValues(newValues);
    setInstanceName(instance.instanceName ? instance.instanceName : "");
    setInstanceObj(instance);
    setCurrentInstanceId(instance.instanceUuid);
    // fetchFiles(instance.instanceUuid);
    if (instance?.status == "published") {
      setActiveTab("chat");
    } else if (instance?.status == "draft") {
      setActiveTab("context");
    }
  };
  const renderReUseActionBtn = (instance) => {
    const handleReuseClick = async (e) => {
      e.preventDefault();
      reset();
      const newValues = {};
      instance.instanceFormData.forEach((item) => {
        // if (item.title !== "Upload File")
        newValues[item._id] = item.value;
      });
      if (formikRef.current) {
        formikRef.current.setValues(newValues);
      }

      const response = await fetchChatToken(
        assistantData?.pluginId,
        assistantData?.uuid
      );
      if (!_.isEmpty(response)) {
        const respData = response.data;
        if (!_.isEmpty(respData.data)) {
          const accessToken = respData.data?.accessToken;
          const assistantInfo = _.clone(assistantData);
          assistantInfo.accessToken = accessToken;
          setAssistantData(assistantInfo);
        }
      }
      // setUserFormData(newValues);
      setInitialValues(newValues);
      setInstanceName(instance.instanceName ? instance.instanceName : "");
      setInstanceObj(instance);
      setCurrentInstanceId(instance.instanceUuid);
      // fetchFiles(instance.instanceUuid);
      if (eventSessionRef.current) {
        eventSessionRef.current.close();
        eventSessionRef.current = null;
        createSseConnection(instance);
      }
      setInstanceUuId(instance);
      if (instance?.status == "published") {
        setActiveTab("chat");
      } else if (instance?.status == "draft") {
        setActiveTab("context");
      }
    };

    const handleDeleteClick = (e) => {
      e.preventDefault();
      deleteInstance(instance.instanceUuid)
        .then(() => {
          fetchFiles(instance.instanceUuid);
          getAssistantDetails(assistantData?.uuid, "", "", "savedContext");
        })
        .catch((err) => {
          console.error("Error deleting instance:", err);
        });
    };
    const modalOpen = (e, uuid) => {
      e.preventDefault();
      setShowUserModal(true);
      setModalId(uuid);
    };
    const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
    return (
      <>
        <span
          className="use-this cursor-pointer"
          onClick={(e) => handleReuseClick(e)}
          title="Use This"
          style={{ margin: "0 2px 0 2px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="#4186BD"
          >
            <path d="M10.0014 14.6757C10.0011 14.6551 10.001 14.6345 10.001 14.6138C10.001 12.1055 12.0175 9.99564 14.7539 9.38092C14.3904 7.07873 11.9602 5.19995 8.90098 5.19995C5.58037 5.19995 3.00098 7.41344 3.00098 9.9793C3.00098 10.9487 3.36131 11.88 4.04082 12.6781C4.0728 12.7157 4.12443 12.7717 4.19342 12.8427C4.78537 13.4517 5.13709 14.2457 5.19546 15.0805C5.90857 14.6683 6.74285 14.5123 7.55832 14.6392C7.72416 14.665 7.85986 14.6847 7.96345 14.6982C8.27111 14.7383 8.58419 14.7586 8.90098 14.7586C9.27825 14.7586 9.64595 14.7301 10.0014 14.6757ZM10.4581 16.627C9.95467 16.7133 9.43399 16.7586 8.90098 16.7586C8.49441 16.7586 8.09502 16.7323 7.70499 16.6815C7.58312 16.6656 7.4317 16.6436 7.25073 16.6154C6.87693 16.5572 6.49436 16.6321 6.1713 16.8268L4.26653 17.9745C4.12052 18.0646 3.94891 18.1057 3.77733 18.0916C3.33814 18.0554 3.01178 17.6744 3.04837 17.2405L3.19859 15.4596C3.23664 15.0086 3.07664 14.5632 2.75931 14.2367C2.66182 14.1364 2.5814 14.0491 2.51802 13.9747C1.56406 12.8542 1.00098 11.4732 1.00098 9.9793C1.00098 6.23517 4.53793 3.19995 8.90098 3.19995C12.9601 3.19995 16.3041 5.82699 16.7504 9.20788C20.1225 9.36136 22.801 11.723 22.801 14.6138C22.801 15.8068 22.3448 16.9097 21.572 17.8044C21.5206 17.8639 21.4555 17.9336 21.3765 18.0137C21.1194 18.2744 20.9898 18.6301 21.0206 18.9903L21.1423 20.4125C21.172 20.759 20.9076 21.0632 20.5518 21.0921C20.4128 21.1034 20.2738 21.0706 20.1555 20.9986L18.6124 20.0821C18.3506 19.9266 18.0407 19.8668 17.7379 19.9133C17.5913 19.9358 17.4686 19.9533 17.3699 19.966C17.0539 20.0066 16.7303 20.0277 16.401 20.0277C13.7074 20.0277 11.4025 18.6201 10.4581 16.627ZM17.4346 17.9364C18.0019 17.8494 18.5793 17.911 19.1105 18.1111C19.2492 17.5503 19.5373 17.0304 19.9524 16.6094C20.0027 16.5585 20.0388 16.5198 20.0584 16.4971C20.5467 15.9318 20.801 15.2839 20.801 14.6138C20.801 12.8095 18.8983 11.2 16.401 11.2C13.9037 11.2 12.001 12.8095 12.001 14.6138C12.001 16.4181 13.9037 18.0277 16.401 18.0277C16.6424 18.0277 16.8809 18.0124 17.115 17.9823C17.1957 17.972 17.3029 17.9566 17.4346 17.9364Z"></path>
          </svg>
        </span>
        {(instance?.userId == currentUser?.emailID &&
          instance?.status != "draft") ||
        stateValue ? (
          <span
            title="Add team member"
            className="use-this cursor-pointer ms-4"
            onClick={(e) => modalOpen(e, instance?.instanceUuid)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="rgba(65,134,189,1)"
            >
              <path d="M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"></path>
            </svg>
          </span>
        ) : (
          <span
            title={`Team members can only be added by the context owner `}
            className="use-this ms-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="rgba(65,134,189,1)"
              style={{ opacity: "0.5", cursor: "not-allowed" }}
            >
              <path d="M14 14.252V16.3414C13.3744 16.1203 12.7013 16 12 16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14C12.6906 14 13.3608 14.0875 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"></path>
            </svg>
          </span>
        )}
        {instance?.userId == currentUser?.emailID || stateValue ? (
          <span
            className="delete-icon ms-4"
            title="Delete"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleDeleteClick(e)}
          >
            <img src="/images/redbin.svg" alt="" />
          </span>
        ) : (
          <span
            className="delete-icon ms-4"
            style={{ opacity: "0.5", cursor: "not-allowed" }}
          >
            <img src="/images/redbin.svg" alt="" />
          </span>
        )}
      </>
    );
  };

  const deleteInstance = async (instanceUuid) => {
    if (accessToken) {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}genai/instance/deactivate`,
        { instanceUuid },
        {
          headers: { "x-access-token": token },
        }
      );
      if (response.status === 200) {
        toast.success(t("contextDelete"));
      }
    } else {
      console.error("No access token provided");
    }
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const renderModalForm = () => {
    return (
      <Modal
        className="custom-modal save-context-modal"
        show={openModal}
        onHide={handleModalClose}
      >
        <ModalHeader closeButton>
          <ModalTitle className="fw-bold">{t("savecontext")}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="upload-file-box">
            <label htmlFor="instance-name">
              {instanceObj?.status == "draft"
                ? t("instanceNameLabel")
                : t("instanceNameChangeLabel")}
            </label>
            <div className="mb-2 description">
              {instanceObj?.status == "draft"
                ? t("instanceNameDescription")
                : t("instanceNameChangeDescription")}
            </div>
            <input
              id="instance-name"
              name="instance-name"
              className="form-control mb-2"
              placeholder=""
              value={instanceName}
              onChange={(e) => {
                setInstanceName(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && instanceName.trim().length >= 3) {
                  e.preventDefault(); // Prevent the default form submission behavior
                  handleSubmit(e, formikInstance.values); // Call the submit function
                }
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="default-btn"
            disabled={instanceName.trim().length < 3}
            onClick={(e) => {
              handleSubmit(e, formikInstance.values);
            }}
          >
            {t("instancePopUpModifyName")}
          </button>
        </ModalFooter>
      </Modal>
    );
  };

  const handleSubmit = async (e, values) => {
    if (!openModal) {
      setOpenModal(true);
      setFormValues(values);
    } else {
      setOpenModal(false);
      setSaveLoading(true);
      setInstanceName(instanceName?.trim());
      let id = "";
      for (let ui of inputUi) {
        if (ui.type === "file") id = ui._id;
      }
      let formData = {};
      Object.keys(values).forEach((key) => {
        if (key === "question" || key == id) {
        } else {
          formData[key] = values[key];
        }
      });
      setUserFormData(formData);

      if (_.isArray(filelist) && !_.isEmpty(filelist)) {
        formData[id] = _.map(filelist, (record, i) => {
          return {
            fileId: record._id,
            fileOriginalName: record.originalname,
            index: record.className,
            fileName: record.filename,
          };
        });
      }
      let saveData = [];
      Object.keys(formData).forEach((key) => {
        for (let ui of inputUi) {
          if (ui._id == key) {
            saveData.push({
              id: ui._id,
              value: formData[key],
              ...ui,
            });
          }
        }
      });

      if (!_.isEmpty(instanceObj)) {
        const instObj = _.clone(instanceObj);
        instObj.instanceFormData = saveData;
        instObj.status = instanceName ? 1 : 0;
        instObj.instanceName = instanceName ? instanceName : "";
        updateAssistantInstanceData(instObj);
      }
    }
  };

  const updateAssistantInstanceData = async (data, id) => {
    try {
      await updateAssistantInstance(data, {
        "x-access-token": assistantData.accessToken,
      })
        .then((response) => {
          setInstanceName("");
          toast.success(t("contextSuccess"));
          setInstanceObj(data);
          let assistantDataTemp = { ...assistantData };
          let check = assistantDataTemp.instanceData.filter(
            (instance) => instance._id == response.data._id
          );
          if (check.length != 0) {
            assistantDataTemp.instanceData = assistantDataTemp.instanceData.map(
              (instance) => {
                if (instance._id == response.data._id) {
                  return response.data;
                }
                return instance;
              }
            );
          } else {
            assistantDataTemp.instanceData = [
              ...assistantDataTemp.instanceData,
              response.data,
            ];
          }
          let newval = {};
          response.data.instanceFormData.forEach((data) => {
            newval[data.id] = data?.value;
          });
          setInitialValues(newval);
          setAssistantData(assistantDataTemp);
          setInstanceName(data?.instanceName || "");
          if (data?.status) {
            setActiveTab("savedContext");
          }
        })
        .catch((error) => {
          console.error("Something went wrong.", error);
        });
    } catch (err) {
      setSaveLoading(false);
      console.error("Something went wrong.", err);
    } finally {
      setSaveLoading(false);
    }
  };

  const generateAssistantInstanceData = async (data) => {
    try {
      await generateAssitantInstanceUUID(data, {
        "x-access-token": assistantData.accessToken,
      })
        .then((response) => {
          if (response.success && !_.isEmpty(response.data)) {
            setInstanceObj(response.data);
          }
          if (!assistantData?.instanceFormData) {
            getAssistantDetails(assistantData?.uuid, "", "", "savedContext");
          }
        })
        .catch((error) => {
          console.error("Something went wrong.", error);
        });
    } catch (err) {
      console.error("Something went wrong.", err);
    } finally {
    }
  };

  const getModalData = (modalId) => {
    return assistantData?.instanceData.find(
      (instance) => instance.instanceUuid === modalId
    );
  };
  const handleUserUpdate = (updatedInstanceData) => {
    setAssistantData((prevData) => ({
      ...prevData,
      instanceData: prevData.instanceData.map((instance) =>
        instance.instanceUuid === modalId ? updatedInstanceData : instance
      ),
    }));
  };
  return (
    <>
      {showUserModal && (
        <AddUserContext
          show={showUserModal}
          onClose={() => {
            setShowUserModal(false);
          }}
          instanceData={getModalData(modalId)}
          onUserUpdate={handleUserUpdate}
        />
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnChange={true}
        validateOnBlur={false}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formikRef}
      >
        {(formik) => {
          // const { handleSubmit } = formik
          formikInstance = formik;
          const focusFirstRequiredEmptyField = (values, fields) => {
            const firstEmptyRequiredField = fields.find(
              (field) => field.required && !values[field._id]
            );
            if (firstEmptyRequiredField) {
              const fieldElement = document.querySelector(
                `[name='${firstEmptyRequiredField._id}']`
              );
              if (fieldElement) {
                fieldElement.focus();
              }
            }
          };
          return (
            <form autoComplete="off">
              {_.isArray(inputUi) && !_.isEmpty(inputUi)
                ? _.map(inputUi, (record, key) => {
                    return <>{renderInputUI(key, record, formik)}</>;
                  })
                : ""}
              {!fromWorkflow && (
                <div className="text-areabox d-flex w-100 justify-content-end">
                  <div className="d-flex gap-3">
                    <button
                      type="submit"
                      variant="primary"
                      className="upload-btn colored d-flex gap-3"
                      onClick={async (e) => {
                        e.preventDefault();
                        const urlUi = inputUi.filter(
                          (record) => record.type == "urllink"
                        );
                        const urlFlag =
                          urlUi[0]?.required && _.isEmpty(dataurl);
                        await formik.validateForm();
                        focusFirstRequiredEmptyField(formik.values, inputUi);
                        if (!isLoading && formik.isValid && !urlFlag) {
                          formik.handleSubmit();
                        } else if (formik.isValid && urlFlag) {
                          toast.info(
                            `Please click on "Capture" button and try saving again`
                          );
                        }
                      }}
                      disabled={isLoading || isFormLoading || saveLoading}
                    >
                      {t("instancePopUpModifyName")}
                    </button>
                  </div>
                </div>
              )}
            </form>
          );
        }}
      </Formik>
      {renderModalForm()}
    </>
  );
};

export default FormikFormComponent;
